import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  firstSectionStyle: {
    marginBottom: 24.7,
    marginLeft: 17.4,
  },
  firstSectionCircleStyle: {
    marginRight: 12,
    width: 71,
    height: 33.3,
    borderRadius: 16.6,
  },
});
